import React from 'react';
import PropTypes from 'prop-types';
import { CmsEntities } from 'client/data/models/cms';
import { LeaseDealsLinkWidget } from 'site-modules/lease-deals/components/lease-deals-link-widget/lease-deals-link-widget';
import { FaqEntry, HtmlEntry, RelatedContentEntry, PageLinksWidgetEntry, PopularLeaseProgramsEntry } from './entries';

const RENDER_TYPE_RENDERERS = {
  faq: FaqEntry,
  html: HtmlEntry,
  'related-content': RelatedContentEntry,
  'page-links-widget': PageLinksWidgetEntry,
  'popular-lease-programs': PopularLeaseProgramsEntry,
  'states-links-widget': LeaseDealsLinkWidget,
};

export function LeaseDealsHiddenGemsEntry({ entry, leaseDealsData = undefined, isMobile = false }) {
  const renderKey = entry.metadata('renderType').value() || entry.id;
  const Component = RENDER_TYPE_RENDERERS[renderKey];

  return Component ? <Component entry={entry} isMobile={isMobile} leaseDealsData={leaseDealsData} /> : null;
}

LeaseDealsHiddenGemsEntry.propTypes = {
  entry: CmsEntities.Content.isRequired,
  leaseDealsData: PropTypes.shape({
    deals: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  isMobile: PropTypes.bool,
};
